var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopMessageOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 17,
  viewBox: "0 0 18 17",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.004 0H4.996A4.996 4.996 0 0 0 0 4.996v4.008l.005.217a5.006 5.006 0 0 0 3.937 4.667l.058.01V17h2.024l3.665-3h3.32A5 5 0 0 0 18 9.004V4.996A5 5 0 0 0 13.004 0M4.996 2h8.008A3 3 0 0 1 16 4.996v4.008A3 3 0 0 1 13.01 12H8.975L6 14.435V12H5c-1.654 0-3-1.346-3-2.996V4.996A2.996 2.996 0 0 1 4.996 2"
})));
export default SvgFacebookDesktopMessageOutlined;